import { APP_CONFIG } from "@config/app.config";
import { Box, Button, Stack, Typography } from "@mui/material"
import { Icon, IconSize } from "@shared/icons";
import WarehouseInventoryCount from "../warehouse-inventory/WarehouseInventoryCount";
import { useState } from "react";

interface ManualWarehouseConnectionButtonProps {
    warehouseId: string;
}

export const ManualWarehouseConnectionButton = ({ warehouseId }: ManualWarehouseConnectionButtonProps) => {

    const [open, setOpen] = useState(false);

    return (
        <>
            <Button fullWidth onClick={() => setOpen(true)} sx={{ p: 3, display: 'flex', gap: 2, alignItems: 'center' }}>

                <Box sx={{ display: 'flex', border: `1px solid ${APP_CONFIG.ui.theme.colors.border}`, borderRadius: 1, width: 100, height: 70, alignItems: 'center', justifyContent: 'center' }}>
                    <Icon icon="Hash02" size={IconSize.LARGE} />
                </Box>


                <Stack direction="row" alignItems="center" justifyContent="space-between" flex={1} >
                    <Typography variant="body2" color="text.primary" gutterBottom>Count your inventory</Typography>
                    <Icon icon="ChevronRight" />
                </Stack>

            </Button>

            <WarehouseInventoryCount warehouseId={warehouseId} onClose={() => setOpen(false)} onSubmit={() => setOpen(false)} open={open} />

        </>
    );
};